
export interface CashfreeSubscriptionOptions {
  paymentSessionId: string;
  onSuccess: (result: any) => void;
  onFailure: (error: any) => void;
}

/**
 * Service to handle Cashfree Subscriptions using the standard Cashfree Web SDK.
 * In a real-world scenario, the paymentSessionId is generated by the backend
 * after creating a Subscription order in Cashfree.
 */
export const processCashfreeSubscription = async (options: CashfreeSubscriptionOptions): Promise<void> => {
  const CashfreeGlobal = (window as any).Cashfree;

  if (!CashfreeGlobal) {
    console.error('Cashfree SDK not found. Ensure the script is included in your HTML.');
    alert('Payment gateway failed to load. Please try again later.');
    options.onFailure('SDK_NOT_FOUND');
    return;
  }

  // Initialize Cashfree
  const cashfree = CashfreeGlobal({
    mode: "sandbox" // Change to "production" for live environment
  });

  console.log(`Initializing Cashfree Checkout for session: ${options.paymentSessionId}`);

  try {
    // Open the Cashfree Checkout components
    const checkoutOptions = {
      paymentSessionId: options.paymentSessionId,
      redirectTarget: "_modal", // Opens in a modal within the page
    };

    const result = await cashfree.checkout(checkoutOptions);

    if (result.error) {
      console.error('Cashfree Checkout Error:', result.error);
      options.onFailure(result.error);
    } else if (result.paymentDetails) {
      console.log('Cashfree Payment Successful:', result.paymentDetails);
      options.onSuccess(result.paymentDetails);
    } else if (result.redirect) {
      console.log('Cashfree Redirecting...');
      // In redirect mode, the result handler doesn't fire immediately
    }
  } catch (error) {
    console.error('Unexpected error during Cashfree checkout:', error);
    options.onFailure(error);
  }
};
